/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BidirectionalActionConfigDate } from './BidirectionalActionConfigDate';
import {
    BidirectionalActionConfigDateFromJSON,
    BidirectionalActionConfigDateFromJSONTyped,
    BidirectionalActionConfigDateToJSON,
} from './BidirectionalActionConfigDate';
import type { BidirectionalActionConfigPhoneNumberExtension } from './BidirectionalActionConfigPhoneNumberExtension';
import {
    BidirectionalActionConfigPhoneNumberExtensionFromJSON,
    BidirectionalActionConfigPhoneNumberExtensionFromJSONTyped,
    BidirectionalActionConfigPhoneNumberExtensionToJSON,
} from './BidirectionalActionConfigPhoneNumberExtension';
import type { BidirectionalActionConfigTextMessage } from './BidirectionalActionConfigTextMessage';
import {
    BidirectionalActionConfigTextMessageFromJSON,
    BidirectionalActionConfigTextMessageFromJSONTyped,
    BidirectionalActionConfigTextMessageToJSON,
} from './BidirectionalActionConfigTextMessage';
import type { BidirectionalActionConfigTime } from './BidirectionalActionConfigTime';
import {
    BidirectionalActionConfigTimeFromJSON,
    BidirectionalActionConfigTimeFromJSONTyped,
    BidirectionalActionConfigTimeToJSON,
} from './BidirectionalActionConfigTime';
import type { BidirectionalActionType } from './BidirectionalActionType';
import {
    BidirectionalActionTypeFromJSON,
    BidirectionalActionTypeFromJSONTyped,
    BidirectionalActionTypeToJSON,
} from './BidirectionalActionType';
import type { Question } from './Question';
import {
    QuestionFromJSON,
    QuestionFromJSONTyped,
    QuestionToJSON,
} from './Question';

/**
 * 
 * @export
 * @interface BidirectionalActionConfig
 */
export interface BidirectionalActionConfig {
    /**
     * 
     * @type {BidirectionalActionType}
     * @memberof BidirectionalActionConfig
     */
    action_type: BidirectionalActionType;
    /**
     * 
     * @type {string}
     * @memberof BidirectionalActionConfig
     */
    connector: BidirectionalActionConfigConnectorEnum;
    /**
     * 
     * @type {Array<Question>}
     * @memberof BidirectionalActionConfig
     */
    questions: Array<Question>;
    /**
     * 
     * @type {BidirectionalActionConfigTextMessage}
     * @memberof BidirectionalActionConfig
     */
    text_message: BidirectionalActionConfigTextMessage;
    /**
     * 
     * @type {BidirectionalActionConfigTextMessage}
     * @memberof BidirectionalActionConfig
     */
    internal_text_message?: BidirectionalActionConfigTextMessage;
    /**
     * 
     * @type {BidirectionalActionConfigDate}
     * @memberof BidirectionalActionConfig
     */
    date?: BidirectionalActionConfigDate;
    /**
     * 
     * @type {BidirectionalActionConfigTime}
     * @memberof BidirectionalActionConfig
     */
    time?: BidirectionalActionConfigTime;
    /**
     * 
     * @type {BidirectionalActionConfigTime}
     * @memberof BidirectionalActionConfig
     */
    phone_number?: BidirectionalActionConfigTime;
    /**
     * 
     * @type {BidirectionalActionConfigPhoneNumberExtension}
     * @memberof BidirectionalActionConfig
     */
    phone_number_extension?: BidirectionalActionConfigPhoneNumberExtension;
}


/**
 * @export
 */
export const BidirectionalActionConfigConnectorEnum = {
    Aida: 'Aida',
    Aidin: 'Aidin',
    Ensocare: 'Ensocare',
    EnsocareVa: 'Ensocare VA',
    EpicCareLink: 'EpicCare Link',
    EpicCareLinkAlbanyMed: 'EpicCare Link Albany Med',
    EpicCareLinkAllinaHealth: 'EpicCare Link Allina Health',
    EpicCareLinkAsante: 'EpicCare Link Asante',
    EpicCareLinkBaptistHealth: 'EpicCare Link Baptist Health',
    EpicCareLinkBenefisHealthSystem: 'EpicCare Link Benefis Health System',
    EpicCareLinkBaylorScottWhiteHealth: 'EpicCare Link Baylor Scott & White Health',
    EpicCareLinkBonSecoursMercyHealth: 'EpicCare Link Bon Secours Mercy Health',
    EpicCareLinkBostonMedicalCenter: 'EpicCare Link Boston Medical Center',
    EpicCareLinkBryanHealth: 'EpicCare Link Bryan Health',
    EpicCareLinkBsaHospital: 'EpicCare Link BSA Hospital',
    EpicCareLinkCapeCodHealthcare: 'EpicCare Link Cape Cod Healthcare',
    EpicCareLinkCaroMont: 'EpicCare Link CaroMont',
    EpicCareLinkChristusHealth: 'EpicCare Link CHRISTUS Health',
    EpicCareLinkCovenantHealthCare: 'EpicCare Link Covenant HealthCare',
    EpicCareLinkDenverHealth: 'EpicCare Link Denver Health',
    EpicCareLinkDukeHealth: 'EpicCare Link Duke Health',
    EpicCareLinkEcuHealth: 'EpicCare Link ECU Health',
    EpicCareLinkElCaminoHealth: 'EpicCare Link El Camino Health',
    EpicCareLinkEnloeHealth: 'EpicCare Link Enloe Health',
    EpicCareLinkFmolhsCareConnect: 'EpicCare Link FMOLHS CareConnect',
    EpicCareLinkParkview: 'EpicCare Link Parkview',
    EpicCareLinkHartfordHealthCare: 'EpicCare Link Hartford HealthCare',
    EpicCareLinkHealthPartners: 'EpicCare Link HealthPartners',
    EpicCareLinkHealtheConnection: 'EpicCare Link HealtheConnection',
    EpicCareLinkHennepinCountyMedicalCenter: 'EpicCare Link Hennepin County Medical Center',
    EpicCareLinkHillcrestHealthCareSystem: 'EpicCare Link Hillcrest HealthCare System',
    EpicCareLinkHospitalSistersHealthSystem: 'EpicCare Link Hospital Sisters Health System',
    EpicCareLinkHurleyMedicalCenter: 'EpicCare Link Hurley Medical Center',
    EpicCareLinkIowaHealthCare: 'EpicCare Link Iowa Health Care',
    EpicCareLinkIntegrisHealth: 'EpicCare Link Integris Health',
    EpicCareLinkKaiserPermanente: 'EpicCare Link Kaiser Permanente',
    EpicCareLinkKingsDaughtersHealthSystem: 'EpicCare Link King\'s Daughters Health System',
    EpicCareLinkLegacyHealthyPlanet: 'EpicCare Link Legacy Healthy Planet',
    EpicCareLinkMHealthFairview: 'EpicCare Link M Health Fairview',
    EpicCareLinkMainLineHealth: 'EpicCare Link Main Line Health',
    EpicCareLinkMayoClinic: 'EpicCare Link Mayo Clinic',
    EpicCareLinkMercy: 'EpicCare Link Mercy',
    EpicCareLinkMiddlesexHealth: 'EpicCare Link Middlesex Health',
    EpicCareLinkMyMichiganHealth: 'EpicCare Link MyMichigan Health',
    EpicCareLinkNortonHealthcare: 'EpicCare Link Norton Healthcare',
    EpicCareLinkNorthMemorialHealth: 'EpicCare Link North Memorial Health',
    EpicCareLinkOhioHealth: 'EpicCare Link OhioHealth',
    EpicCareLinkOklahomaHeartHospital: 'EpicCare Link Oklahoma Heart Hospital',
    EpicCareLinkOwensboroHealth: 'EpicCare Link Owensboro Health',
    EpicCareLinkPiedmont: 'EpicCare Link Piedmont',
    EpicCareLinkProvidence: 'EpicCare Link Providence',
    EpicCareLinkSaintFrancis: 'EpicCare Link Saint Francis',
    EpicCareLinkShannonHealth: 'EpicCare Link Shannon Health',
    EpicCareLinkSsmHealth: 'EpicCare Link SSM Health',
    EpicCareLinkTexasHealth: 'EpicCare Link Texas Health',
    EpicCareLinkTheQueensHealthSystem: 'EpicCare Link The Queen\'s Health System',
    EpicCareLinkTriHealth: 'EpicCare Link TriHealth',
    EpicCareLinkTrinityHealth: 'EpicCare Link Trinity Health',
    EpicCareLinkUcHealth: 'EpicCare Link UCHealth',
    EpicCareLinkUncHealth: 'EpicCare Link UNC Health',
    EpicCareLinkUConnHealth: 'EpicCare Link UConn Health',
    EpicCareLinkUnityPointHealth: 'EpicCare Link UnityPoint Health',
    EpicCareLinkUniversityOfCincinnati: 'EpicCare Link University of Cincinnati',
    EpicCareLinkUniversityOfKansas: 'EpicCare Link University of Kansas',
    EpicCareLinkUniversityOfUtah: 'EpicCare Link University of Utah',
    EpicCareLinkUpmcPinnacle: 'EpicCare Link UPMC Pinnacle',
    EpicCareLinkSouthShoreHealth: 'EpicCare Link South Shore Health',
    EpicCareLinkStLukes: 'EpicCare Link St. Luke\'s',
    EpicCareLinkPremierHealth: 'EpicCare Link Premier Health',
    EpicCareLinkUtHealthEastTexas: 'EpicCare Link UT Health East Texas',
    EpicCareLinkUtSouthwesternMedicalCenter: 'EpicCare Link UT Southwestern Medical Center',
    EpicCareLinkVitruvianHealth: 'EpicCare Link Vitruvian Health',
    EpicCareLinkWellstar: 'EpicCare Link Wellstar',
    EpicCareLinkKetteringHealth: 'EpicCare Link Kettering Health',
    Fax: 'Fax',
    ManualUpload: 'Manual Upload',
    ManualCopy: 'Manual Copy',
    WellSkyIntake: 'WellSky Intake',
    WellSkyIntakeCarePortQuickCase: 'WellSky Intake CarePort QuickCase',
    WellSkyReferralManagement: 'WellSky Referral Management',
    WellSkyReferralManagementWebReferral: 'WellSky Referral Management Web Referral',
    FourNext: 'Four Next'
} as const;
export type BidirectionalActionConfigConnectorEnum = typeof BidirectionalActionConfigConnectorEnum[keyof typeof BidirectionalActionConfigConnectorEnum];


/**
 * Check if a given object implements the BidirectionalActionConfig interface.
 */
export function instanceOfBidirectionalActionConfig(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "action_type" in value;
    isInstance = isInstance && "connector" in value;
    isInstance = isInstance && "questions" in value;
    isInstance = isInstance && "text_message" in value;

    return isInstance;
}

export function BidirectionalActionConfigFromJSON(json: any): BidirectionalActionConfig {
    return BidirectionalActionConfigFromJSONTyped(json, false);
}

export function BidirectionalActionConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): BidirectionalActionConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'action_type': BidirectionalActionTypeFromJSON(json['action_type']),
        'connector': json['connector'],
        'questions': ((json['questions'] as Array<any>).map(QuestionFromJSON)),
        'text_message': BidirectionalActionConfigTextMessageFromJSON(json['text_message']),
        'internal_text_message': !exists(json, 'internal_text_message') ? undefined : BidirectionalActionConfigTextMessageFromJSON(json['internal_text_message']),
        'date': !exists(json, 'date') ? undefined : BidirectionalActionConfigDateFromJSON(json['date']),
        'time': !exists(json, 'time') ? undefined : BidirectionalActionConfigTimeFromJSON(json['time']),
        'phone_number': !exists(json, 'phone_number') ? undefined : BidirectionalActionConfigTimeFromJSON(json['phone_number']),
        'phone_number_extension': !exists(json, 'phone_number_extension') ? undefined : BidirectionalActionConfigPhoneNumberExtensionFromJSON(json['phone_number_extension']),
    };
}

export function BidirectionalActionConfigToJSON(value?: BidirectionalActionConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action_type': BidirectionalActionTypeToJSON(value.action_type),
        'connector': value.connector,
        'questions': ((value.questions as Array<any>).map(QuestionToJSON)),
        'text_message': BidirectionalActionConfigTextMessageToJSON(value.text_message),
        'internal_text_message': BidirectionalActionConfigTextMessageToJSON(value.internal_text_message),
        'date': BidirectionalActionConfigDateToJSON(value.date),
        'time': BidirectionalActionConfigTimeToJSON(value.time),
        'phone_number': BidirectionalActionConfigTimeToJSON(value.phone_number),
        'phone_number_extension': BidirectionalActionConfigPhoneNumberExtensionToJSON(value.phone_number_extension),
    };
}

